import Head from 'next/head';

import StarList from './components/star-list';
import TagList from './components/tag-list';
import { useEffect } from 'react';
import { request } from '@/lib';
import { useArray, useSetState } from 'react-hanger';

import tagStyle from './static/tag.module.scss';
import { LoadingBlock } from 'components';

const a = tagStyle.a;

const Index = (props) => {
  const { state: data, setState } = useSetState(null);

  useEffect(() => {
    Promise.all([
      request.cryolite.get(
        '/api/v3/hot/room_list?live_type=0&offset=0&limit=24',
      ),
      request.api.get('labelpub/list'),
    ])
      .then((res) => {
        setState({
          room_list: res[0].data.data.items,
          tag_list: res[1].items,
        });

        import('./static/tag');
      })
      .catch((res) => {
        console.error(res);
      });
  }, []);

  if (!data) {
    return <LoadingBlock page></LoadingBlock>;
  }

  return (
    <div className="container">
      <div className="main">
        <div className="mod mod-tag">
          <div className="mod-hd">
            <h2>全部主播</h2>
          </div>
          <div className="mod-bd ">
            <ul className="fix" id="j_star_list">
              <StarList
                data={data.room_list}
                max={24}
                clickfrom="J137"
              ></StarList>
            </ul>
            <div className="mod-datatip text-primary" id="j_mod_loading">
              正在为您努力加载…
            </div>
            <div className="mod-datatip text-primary" id="j_mod_finished">
              主播都被你找完啦
            </div>

            <div className="mod-more" id="j_mode_more">
              <div className="mod-more-line"></div>
              <a>
                <span>
                  <i className="btn btn-sm btn-primary">加载更多</i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="aside">
        <div className="" id="j_fixed_aside">
          <div className="mod aside-mod">
            <div className="aside-mod-hd">
              <span>全部标签</span>
            </div>
            <div className="aside-mod-bd">
              <ul className="fix">
                <TagList data={data.tag_list}></TagList>
              </ul>
            </div>
          </div>
          <div className="mod aside-download">
            <p>客户端支持管理自己喜欢的标签啦，</p>
            <p>还不快去下载！</p>
            <div className="aside-download-icon"></div>
          </div>
          <div className="back-top" id="j_back_top" title="返回顶部">
            <h1>
              <i className="iconfont icon-icon-arrow-top4"></i>
            </h1>
            <p>回顶端</p>
          </div>
        </div>
      </div>
    </div>
  );
};

Index.getInitialProps = async (ctx) => {
  return {
    currentPage: 'tag',
  };
};

export default Index;
